import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from 'components/Buttons';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const AskProductOrderDetailsWrapper = styled.div<{
  isActive: boolean;
  compact: boolean;
}>`
  margin-top: ${({ compact }) => (compact ? 0 : pxToEm(23))};
  min-height: ${({ isActive, compact }) =>
    compact && isActive ? pxToEm(0) : pxToEm(40)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const OrderDetailsToggle = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  ${({ isActive }) =>
    isActive
      ? css`
          gap: initial;
        `
      : css`
          gap: ${pxToEm(24)};
        `}
  }
`;

export const OrderDetailsThumbnails = styled.div`
  display: flex;
  margin-bottom: ${pxToEm(-2)};
`;

export const OrderDetailsThumbnail = styled.div<{ bg?: string }>`
  width: ${pxToEm(40)};
  height: ${pxToEm(40)};
  box-sizing: border-box;
  border-radius: ${pxToEm(12)};
  background-image: url(${({ bg }) => bg});
  background-size: cover;
  background-position: center;
  border: ${pxToEm(2)} solid ${palette.grey[200]};
  margin-right: ${pxToEm(-20)};
`;

export const OrderDetailsCounter = styled(OrderDetailsThumbnail)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${pxToEm(16)};
  font-weight: 600;
  background-color: ${palette.grey[300]};

  span {
    color: ${palette.grey['A400']};
  }
`;

export const ToggleButton = styled(Button)<{
  isActive: boolean;
  compact?: boolean;
}>`
  padding-left: 0;
  padding-right: 0;

  ${({ compact, isActive }) =>
    isActive &&
    compact &&
    css`
      position: absolute;
      top: ${pxToEm(6)};
      right: 0;
    `}

  svg {
    width: ${pxToEm(42)} !important;
  }
  ${({ isActive }) =>
    isActive &&
    css`
      svg {
        transform: rotateX(180deg);
      }
    `}
  &:focus {
    color: ${palette.grey['800']};
  }
  &:hover {
    color: ${palette.grey['800']};
  }

  > span {
    margin-left: 0;
  }
`;
